import React from 'react'
import Grid from '@material-ui/core/Grid'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import TableContainer from '@material-ui/core/TableContainer'
import Header from './Header'
import Button from '@material-ui/core/Button'
import axios from 'axios'
import {Redirect} from 'react-router-dom'


class EditRmaform extends React.Component
{

constructor(props)
{

    super(props)
    this.state={
       records:[],
       complaintid:'',
       complaintreply:'',
       success:'',
       redirect:false,
       errors:{},
       productname:'',
       location:'',
       customername:'',
       salestaff:'',
       invoiceno:'',
       invoicedate:'',
       emailid:'',
       complaint:'',
       rmaid:'',
       phone:''
    }   
}    
componentDidMount()
{
    const {match:{params}}= this.props
    this.setState({complaintid:params.cid})
    axios({method:'post',url:`https://www.thespiritofdubai.com/rmaform/php/fetchrecord.php?cid=${params.cid}`,
    mode:'no-core',
    withCredentials:false}).then((res)=>
    {
      
      this.setState({records:res.data})  
      this.setState({complaintreply:res.data[0]['complaintreply']})
      this.setState({productname:res.data[0]['productname']})
      this.setState({location:res.data[0]['location']})
      this.setState({salestaff:res.data[0]['salestaff']})
      this.setState({invoiceno:res.data[0]['invoiceno']})
      this.setState({invoicedate:res.data[0]['invoicedate']}) 
      this.setState({customername:res.data[0]['customername']}) 
      this.setState({emailid:res.data[0]['email']}) 
      this.setState({complaint:res.data[0]['complaint']}) 
      this.setState({image:res.data[0]['image']}) 
      this.setState({rmaid:res.data[0]['rmaid']})
      this.setState({signature:res.data[0]['signature']}) 
      this.setState({phone:res.data[0]['phone']}) 
      this.setState({comments:res.data[0]['comments']}) 


      //alert(res.data[0]['complaintreply'])
     
    })
}
handleChange=(e)=>
{
    this.setState({complaintreply:e.target.value})
}
handleSubmit=()=>
{
if(this.validateform())
{
const postdata={
    reply:this.state.complaintreply,
    complaintid:this.state.complaintid
}    
axios({
    method:"post",
    url:"https://www.thespiritofdubai.com/rmaform/php/updatecomplaintreply.php",
    mode:"no-core",
    withCredentials:false,
    data:postdata
}).
then((res)=>{
  // alert(res)
  this.setState({redirect:true})
   this.setState({complaintreply:res.data})
   this.setState({success:'Record Saved Successfully'})
   
  
})
}
}
validateform()
{
   let formisvalid=true
   let errors={}
   
   if(!this.state.complaintreply)
   {
       formisvalid=false
       errors['complaintreplynerr']='Please enter Reply'
   }
   this.setState({errors:errors})
   return formisvalid
}

render()
{
 
    const suc={
        color:"green"
    }
    const err={
        color:"red"
    }

    if(this.state.redirect)
    {
     return (<Redirect to="/view" />)
    }
   
    const IMG_PATH='https://www.thespiritofdubai.com/rmaform/php/upload/'
    return(
        <>
        <Grid container direction="row" justify="center" alignItems="center">
        <Grid item xs={12}>
        <form>  
         <input type='hidden' name='complaintid' value={this.state.complaintid} />    
        <TableContainer >
        <Table style={{width:"90%",margin:"auto"}}>
        <Header />
        <TableBody>
        <TableRow>
            <TableCell align="center" colSpan="2" style={{height:"20px"}}><h6><u>RETURN MERCHANDISE AUTHORIZATION</u></h6></TableCell>
            
        </TableRow>
        <TableRow>
    <TableCell style={suc} colSpan="2" align='center'>{this.state.success}</TableCell>

            </TableRow>
        <TableRow>
      
        
       
           <TableCell style={{width:"40%"}} valign="top">
           <Table style={{width:"100%"}} >
      
       <TableRow>
           <TableCell colSpan="2" style={{lineHeight:"10px"}} valign="top">
               <h5 style={{margin:"10px"}}>
               <u>SALES STAFF:</u>
               </h5></TableCell>
       </TableRow>
            <TableRow>
            <TableCell>
            Product : {this.state.productname}
            </TableCell>
            </TableRow>
             <TableRow>
             <TableCell>
             Location : {this.state.location}
             </TableCell>
         </TableRow>
         <TableRow>
            <TableCell>
            Sales Staff :{this.state.salestaff}
            </TableCell>
        </TableRow>
        <TableRow>
            <TableCell>
            Invoice No# : {this.state.invoiceno}
            </TableCell>
        </TableRow>
        <TableRow>
            <TableCell>
            Invoice Date :  {this.state.invoicedate}
            </TableCell>
        </TableRow>
        <TableRow>
            <TableCell>
            Comments :  {this.state.comments}
            </TableCell>
        </TableRow>
        <TableRow>
            <TableCell style={{height:"300px"}}>
            &nbsp;
            </TableCell>
        </TableRow>
       
        </Table></TableCell>
    
 
        <TableCell style={{width:"40%"}}>
        <Table style={{width:"100%"}} >
   
    <TableRow>
        <TableCell colSpan="2" style={{lineHeight:"10px"}}>
            <h5 style={{margin:"10px"}}>
            <u>CUSTOMER:</u>
            </h5></TableCell>
    </TableRow>
    <TableRow>
            <TableCell>
            Ref : {this.state.rmaid}
            </TableCell>
        </TableRow>
        <TableRow>
            <TableCell>
            Name : {this.state.customername}
            </TableCell>
        </TableRow>
        <TableRow>
            <TableCell>
            Phone : {this.state.phone}
            </TableCell>
        </TableRow>
        <TableRow>
            <TableCell>
            Email : {this.state.emailid}
            </TableCell>
        </TableRow>
        <TableRow>
            <TableCell>
            Nature of Complaint :  {this.state.complaint}
            </TableCell>
        </TableRow>
        <TableRow>
            <TableCell>
            Photo : <img src={`${IMG_PATH}`+`${this.state.image}`} width="100" height="auto" alt="RMA" />
            </TableCell>
        </TableRow>
        <TableRow>
            <TableCell>
            Signature : <img src={this.state.signature} width="100" height="auto" alt="RMA"/>
            </TableCell>
        </TableRow>
        <TableRow>
            <TableCell>
           &nbsp;
            </TableCell>
        </TableRow>
        </Table></TableCell>
 
      
    </TableRow>
        
    <TableRow>
           
      <TableCell style={{width:"100%"}} colSpan="2">
                <Table style={{width:"100%"}}>
              <TableRow>
        <TableCell >Complaint</TableCell>
            <TableCell colSpan="3">
          
            <textarea isRequired={true} variant='outlined' name='complaintreply' value={this.state.complaintreply} onChange={this.handleChange} cols="100" rows="5"></textarea>
            <div style={err}>{this.state.errors.complaintreplyerr}</div> 
           
            </TableCell>
       </TableRow>
       </Table>
       </TableCell>
       </TableRow>

       <TableRow>
            <TableCell align="center" colSpan={2}>
                    <Button color='secondary' variant='contained' onClick={this.handleSubmit}>Submit</Button>
            </TableCell>
        </TableRow>            
               
    </TableBody>
    </Table>
    </TableContainer>  
    </form> 
    </Grid>     
    </Grid>
        </>
    )
}

}
export default EditRmaform